import React, { useState, useEffect, useMemo, useRef } from "react";
import { NavLink } from "react-router-dom";
import { Grid, TextField, LinearProgress, Button } from "@mui/material";
import ReactPaginate from "react-paginate";
// COMPONENTS
import Table from "../../Components/Common/Table/Table";
// FUNCTIONS
import {
  CommonSubHeader,
  getInfoMessageNoResultsSearch,
} from "../../Components/helpers/Helpers";
import TableActions from "../../Components/Common/Table/TableActions";
import { Groups2 } from "@mui/icons-material";
import api from "../../api/axios";

function Groups() {
  // Estados principales
  const [groups, setGroups] = useState([]);
  const [objPerPage, setObjPerPage] = useState(10);
  const [totalPagesNumber, setTotalPagesNumber] = useState(0);
  const [pageCount, setPageCount] = useState(0);
  const [pagePressed, setPagePressed] = useState(1);
  const [loading, setLoading] = useState(false);

  // Obtener datos
  const getDataGroups = async () => {
    setLoading(true);
    try {
      const { data } = await api.post(
        `${process.env.REACT_APP_API_URL}/groups`,
        {
          page: pagePressed,
          objPerPage,
        },
      );

      const { data: groupsData, total, last_page } = data.groups;
      updateState(groupsData, total, last_page);
    } catch (error) {
      console.error("Error en la respuesta del servidor:", error);
    } finally {
      setLoading(false); // Asegúrate de restablecer el estado de carga
    }
  };

  // Función para actualizar el estado
  const updateState = (groupsData, total, lastPage) => {
    setGroups(groupsData);
    setTotalPagesNumber(total);
    setPageCount(lastPage);
  };

  useEffect(() => {
    getDataGroups();
  }, [pagePressed]);

  const handlePageClick = (event) => {
    setPagePressed(event.selected + 1);
  };

  const columns = useMemo(
    () => [
      {
        Header: "LISTA DE GRUPOS",
        columns: [
          {
            Header: "Grupo",
            accessor: "grupo",
            width: 300,
            minWidth: 300,
            Cell: ({ value }) => {
              let contenido = <div style={{ marginLeft: "20px" }}>{value}</div>;
              return contenido;
            },
          },
          {
            Header: "Acciones",
            accessor: "id",
            width: 50,
            minWidth: 50,
            Cell: ({ value }) =>
              TableActions != null && (
                <TableActions
                  rute={"grupos"}
                  value={value}
                  showEdit
                  module="group"
                  apiRute="groups"
                />
              ),
          },
        ],
      },
    ],
    [],
  );

  return (
    <div className="fatherContainer">
      <CommonSubHeader title="Configuración" subTitle="Grupos" />

      <div className="mainContainer">
        <div className="subMainContainer">
          {loading && <LinearProgress color="success" />}
          <Table
            columns={columns}
            data={groups}
            view="grupo"
            viewTitle="grupos"
            totalPagesNumber={totalPagesNumber}
            tableWidth={"unset"}
            minTableWidth={"50%"}
            icon={Groups2}
          />
          {totalPagesNumber > 10 && (
            <div className="tablePaginateContainer">
              <div className="paginatorLeftText">
                Mostrando {objPerPage * (pagePressed - 1) + 1} a{" "}
                {Math.min(objPerPage * pagePressed, totalPagesNumber)} de{" "}
                {totalPagesNumber} resultados
              </div>
              <ReactPaginate
                breakLabel="..."
                nextLabel="Siguiente 🢂"
                onPageChange={handlePageClick}
                pageRangeDisplayed={3}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="🢀 Anterior"
                containerClassName="pagination"
                activeClassName="active"
                pageClassName="page-item"
                nextClassName="page-item"
                previousClassName="page-item"
                disabledClassName="disabled"
              />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default Groups;
